import { RootState } from '../store';

export const selectLoginStatus = (state: RootState) =>
  state.adminReducer.succeeded;

export const selectIsLoading = (state: RootState) => state.adminReducer.loading;

export const selectIsRejected = (state: RootState) =>
  state.adminReducer.isRejected;

export const selectLoginData = (state: RootState) =>
  state.adminReducer.loginData;

export const selectRejectedMessage = (state: RootState) =>
  state.adminReducer.errorMessage;

export const selectChangePasswordStatus = (state: RootState) =>
  state.adminReducer.changePasswordSuccessed;

export const selectResetPasswordStatus = (state: RootState) =>
  state.adminReducer.resetPasswordSuccessed;

export const selectResetPasswordConfirmStatus = (state: RootState) =>
  state.adminReducer.resetPasswordConfirmSuccessed;
